module.exports = __webpack_public_path__ + "img/banner-new.33bb2417.jpg";